import { render, staticRenderFns } from "./AssignedLifecycle.vue?vue&type=template&id=422271fa"
import script from "./AssignedLifecycle.vue?vue&type=script&lang=js"
export * from "./AssignedLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports